import { groupHomolableItems } from '../helpers'

/**
 * Return the first pivot of the pivotItems list.
 * @param {Object} state
 */
function pivotItem(state) {
  return state.pivotItems[0];
}


/**
 * A simple getter to compute the actual page of the qmps.
 * @param {Object} state
 */
function qmpsPage(state) {
  return Math.floor(state.qmpsOffset / state.qmpsFetch) + 1;
}


/**
 * Return the similar items that are different from the pivot one.
 * This is useful because the backend returns the similar items containing
 * the pivot one.
 *
 * @param {Object} state
 * @param {Object} getters
 */
function filteredSimilarItems(state, getters) {
  const pivot = getters.pivotItem
  const items = state.similarItems
  const sellerHomologations = state.sellerHomologations
  const qmpsIds = []
  let filteredItems = items
  /* Filter to get only items different from the pivot */
  .filter(item => item.sellerId !== pivot.sellerId || item.historyId !== pivot.historyId)
  /* Hide or show the items with productId */
  .filter(item => state.similarItemsHideThoseWithQmp ? !item.productId : true)
  /* Show only the most similar item per QMP */
  .filter(item => {
    if (item.productId) {
      if (qmpsIds.some(id => id === item.productId)) {
        return false
      }
      qmpsIds.push(item.productId)
    }
    return true
  })
  filteredItems = groupHomolableItems(filteredItems, sellerHomologations);
  return filteredItems;
}

/**
 * Return the selected items grouped based on the sellerHomologations variable
 *
 * @param {Object} state
 */
function groupedSelectedItems(state) {
  const selectedItems = state.selectedItems
  const sellerHomologations = state.sellerHomologations
  const groupedSelectedItems = groupHomolableItems(selectedItems, sellerHomologations);
  return groupedSelectedItems;
}


/**
 * Get an object with the productId as the key of the group and the value an array
 * of similar items.
 * @param {Object} state
 * @param {Object} getters
 */
function similarItemsByProductId(state, getters) {
  const grouped = {}
  getters.filteredSimilarItems.forEach(item => {
    if (!grouped[item.productId]) grouped[item.productId] = []
    grouped[item.productId].push(item)
  })
  return grouped
}


/**
 * Get the page (1-indexed) of the similar items.
 * @param {Object} state
 */
function similarItemsPage(state) {
  return Math.floor(state.similarItemsOffset / state.similarItemsFetch) + 1;
}


export default {
  pivotItem,
  qmpsPage,
  filteredSimilarItems,
  similarItemsByProductId,
  similarItemsPage,
  groupedSelectedItems
}
